import styled from 'styled-components';

import THEME from '../../../../../constants/theme';

export const Text = styled.p`
  color: ${THEME.bobBlack};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  margin: 0;
`;
